// extracted by mini-css-extract-plugin
module.exports = {"RV-G":"EU_RV-G__wn_7e"};